import styled from 'styled-components';
import Colors from '@/constants/Colors';

export const StyledTaskActivitiesEditor = styled.div`
  flex: 1;
  height: 100%;

  .activities-container {
    height: 100%;
    padding: 20px;
    background: ${Colors.backgroundPaleBlue};
    border-radius: 8px;
    overflow-y: auto;

    .activities {
      .activity {
        border-bottom: 1px solid white;
        padding: 10px 0px;
        display: flex;
        flex-direction: column;
        gap: 5px;

        &.available {
          padding: 5px 8px;
          background: ${Colors.secondBackground};
          border-radius: 5px;
          margin-bottom: 2px;
        }

        .activity-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          .name {
            display: flex;
            flex-direction: column;
            gap: 0;

            .miniactivity {
              font-size: 85%;
            }
          }
          .actions {
            display: flex;
            gap: 15px;
            align-items: center;
            .drag-icon {
              font-size: 20px;
            }
          }
        }

        .options {
          padding: 5px;
          border-radius: 3px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          justify-content: space-between;

          .repetitions,
          .questions-per-screen {
            font-size: 12px;
            .ant-input-number-group {
              width: 80px;
              .ant-input-number-group-addon {
                padding: 0px 4px;
              }
            }
            .repetitions-text {
              font-size: 12px;
            }
          }

          .questions-per-screen {
            .ant-input-number-group {
              width: 159px;
            }
          }

          .single-option-selector {
            font-size: 12px;
            min-width: 100px;
          }
        }
      }

      .separator {
        margin: 20px 0px 10px;
        font-weight: bold;
      }
    }
  }

  .ant-spin-nested-loading,
  .ant-spin-container {
    height: 100%;
  }
`;
